import { render, staticRenderFns } from "./PreviousCalls.vue?vue&type=template&id=b15af3c0"
import script from "./PreviousCalls.vue?vue&type=script&lang=js"
export * from "./PreviousCalls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports